import React from 'react';
import { useEditCompanyContext } from '../context';
import * as S from './styles';

export function Content() {
	const { steps, currentStep } = useEditCompanyContext();

	return <S.Container span={24}>{steps[currentStep]?.component}</S.Container>;
}
